import { pagination } from 'instantsearch.js/es/widgets';
import { connectPagination } from 'instantsearch.js/es/connectors';
import { paginationClasses } from './common.js';

/**
 * Create pagination widget with Tailwind styling
 * Automatically hides when there's only one page
 * @param {string} containerSelector - CSS selector for pagination container
 * @param {string} scrollToSelector - CSS selector for scroll target
 * @returns {Object|null} Pagination widget instance or null
 */
export function createPagination(
  containerSelector = '[data-pagination]',
  scrollToSelector = '[data-search-robots]',
) {
  const container = document.querySelector(containerSelector);

  if (!container) {
    return null;
  }

  // Create the main pagination widget
  const paginationWidget = pagination({
    container,
    padding: 2,
    showFirst: false,
    showLast: false,
    showPrevious: true,
    showNext: true,
    scrollTo: scrollToSelector,
    templates: {
      previous:
        '<svg class="size-3" aria-hidden="true"><use href="#icon-chevron-left"></use></svg>',
      next: '<svg class="size-3 rotate-180" aria-hidden="true"><use href="#icon-chevron-left"></use></svg>',
    },
    cssClasses: paginationClasses,
  });

  return paginationWidget;
}

/**
 * Create a visibility controller for pagination
 * Hides the pagination container when there's only one page
 * @param {string} containerSelector - CSS selector for pagination container
 * @returns {Object|null} Connector widget instance or null
 */
export function createPaginationVisibility(
  containerSelector = '[data-pagination]',
) {
  const container = document.querySelector(containerSelector);

  if (!container) {
    return null;
  }

  // Add transition class for smooth fade
  container.classList.add('transition-opacity', 'duration-300');

  return connectPagination(({ nbPages }) => {
    if (nbPages <= 1) {
      container.classList.add('opacity-0', 'pointer-events-none');
    } else {
      container.classList.remove('opacity-0', 'pointer-events-none');
    }
  })();
}
